const NameThisListCard = (props) => 
  <fieldset className="share_list_form_section">
    <div className="share_list_title_holder">
      <div className="share_list_title">{props.name}</div>
    </div>
  </fieldset>

export default NameThisListCard;